export const SET_FORM_NOTIFICATION_SETTINGS = 'SET_FORM_NOTIFICATION_SETTINGS';
export const RESET_FORM_NOTIFICATION_SETTINGS =
  'RESET_FORM_NOTIFICATION_SETTINGS';
export const SET_SUBJECTS_NOTIFICATION_SETTINGS =
  'SET_SUBJECTS_NOTIFICATION_SETTINGS';
